import React from "react";
import classes from "./MatchEvents.module.css";
import { useTranslation } from "react-i18next";

const MatchEvents = ({ team_name, data }) => {
  const {t}=useTranslation();
  return (
    <div className={classes.panel_container}>
        <div className={classes.panel_header}>
            <p className={classes.panel_header_heading}>{team_name}</p>
        </div>
      {data?.length > 0 ? (
        data?.map((dataItem) => {
          return (
            <div className={classes.container}>
              <p className={classes.name}>{dataItem?.player?.name}</p>
              <p className={classes.time}>{dataItem?.time?.elapsed}`</p>
            </div>
          );
        })
      ) : (
        <div className={classes.container}>
          <p className={classes.name}>
              {t("147")}
          </p>
        </div>
      )}
    </div>
  );
};

export default MatchEvents;
